// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"02736dbc","523":"43e1ac36"}[chunkId] + ".chunk.css";
};